import {
  filterCollaboratorsData,
  setCollaboratorSettingFilterTitle,
  setFilterBuValue,
  setFilterRegimeValue,
  setFilterRoleValue,
  setFilterZoneValue
} from "Actions";
import _ from "i18n";
import debounce from "lodash.debounce";
import React, { Component } from "react";
import { connect } from "react-redux";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
class CollaboratorSettingFilter extends Component {
  constructor(props) {
    super(props);
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 100);
  }
  handleSearchInputChange(word) {
    const { dispatch, data } = this.props;

    if (word.length > 2 || word.length === 0) {
      // Set the filter title in Redux
      dispatch(setCollaboratorSettingFilterTitle(word));

      // Filter data locally
      let filteredData = [...data];
      if (word && word.length > 0) {
        filteredData = filteredData.filter(
          c => c.name && c.name.toLowerCase().includes(word.toLowerCase())
        );
      }

      // Dispatch action to update filtered data
      dispatch(filterCollaboratorsData(filteredData));
    }
  }

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  applyFilters = (zone, bu, regime, role) => {
    const { dispatch, data } = this.props;

    let filteredData = data;

    if (zone && !isNaN(zone)) {
      filteredData = filteredData.filter(c => c.zone === zone);
    }

    if (bu && !isNaN(bu)) {
      filteredData = filteredData.filter(c => c.bu === bu);
    }

    if (regime && !isNaN(regime)) {
      filteredData = filteredData.filter(c => c.regime === regime);
    }

    if (role && !isNaN(role)) {
      filteredData = filteredData.filter(c => c.role === role);
    }

    dispatch(filterCollaboratorsData(filteredData));
  };

  handleZoneChange = item => {
    const {
      dispatch,
      filter: { bu, regime, role }
    } = this.props;
    const zone = parseInt(item, 10);
    dispatch(setFilterZoneValue(zone));
    this.applyFilters(zone, bu, regime, role);
  };

  handleBuChange = item => {
    const {
      dispatch,
      filter: { zone, regime, role }
    } = this.props;
    const bu = parseInt(item, 10);
    dispatch(setFilterBuValue(bu));
    this.applyFilters(zone, bu, regime, role);
  };

  handleRegimeChange = item => {
    const {
      dispatch,
      filter: { zone, bu, role }
    } = this.props;
    const regime = parseInt(item, 10);
    dispatch(setFilterRegimeValue(regime));
    this.applyFilters(zone, bu, regime, role);
  };

  handleRoleChange = item => {
    const {
      dispatch,
      filter: { zone, bu, regime }
    } = this.props;
    const role = parseInt(item, 10);
    dispatch(setFilterRoleValue(role));
    this.applyFilters(zone, bu, regime, role);
  };

  render() {
    const {
      customAddOn,
      collaboratorsFilter,
      nbResult,
      fetching,
      settingSuggestions,
      filter
    } = this.props;

    const suggestions = settingSuggestions && settingSuggestions.data;

    let zoneOptions =
      suggestions &&
      settingSuggestions.data.zones &&
      settingSuggestions.data.zones.map(zone => {
        return { label: zone.label, value: zone.id };
      });

    let buOptions =
      suggestions &&
      settingSuggestions.data.bus &&
      settingSuggestions.data.bus.map(bu => {
        return { label: bu.label, value: bu.id };
      });

    let regimeOptions =
      suggestions &&
      settingSuggestions.data.regimes &&
      settingSuggestions.data.regimes.map(regime => {
        return {
          label: regime.label,
          value: regime.id
        };
      });

    let roleOptions =
      suggestions &&
      settingSuggestions.data.roles &&
      settingSuggestions.data.roles.map(role => {
        return {
          label: _(role.label === "manager" ? "folderManager" : role.label),
          value: role.id
        };
      });

    const filters = [
      {
        type: "SELECT",
        options: {
          isSimple: true,
          isMulti: false,
          isClearable: true,
          placeholder: _("zone"),
          options: zoneOptions ? zoneOptions : [],
          values: filter.zone,
          action: this.handleZoneChange
        }
      },
      {
        type: "SELECT",
        options: {
          isSimple: true,
          isMulti: false,
          isClearable: true,
          placeholder: _("bu"),
          options: buOptions ? buOptions : [],
          values: filter.bu,
          action: this.handleBuChange
        }
      },
      {
        type: "SELECT",
        options: {
          isSimple: true,
          isMulti: false,
          isClearable: true,
          placeholder: _("regime"),
          options: regimeOptions ? regimeOptions : [],
          values: filter.regime,
          action: this.handleRegimeChange
        }
      },
      {
        type: "SELECT",
        options: {
          isSimple: true,
          isMulti: false,
          isClearable: true,
          placeholder: _("role"),
          options: roleOptions ? roleOptions : [],
          values: filter.role,
          action: this.handleRoleChange
        }
      }
    ];

    return (
      <div className="row align-center">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button
            customAddOn={customAddOn}
            filter={filter}
            filters={filters}
            searchInputValue={collaboratorsFilter.label}
            searchPlaceholder="Search by name"
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
            nbResult={nbResult}
            label={_("collaboratorNumber")}
            marginLeft={"10em"}
            fetching={fetching}
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  collaboratorsFilter: state.collaborator.filter,
  settingSuggestions: state.collaborator.settingSuggestions,
  lng: state.params.lng
});

export default connect(mapStateToProps)(CollaboratorSettingFilter);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/CollaboratorSettingFilter.js